import { makeStyles } from '@material-ui/styles'
import React from 'react'

const useStyles = makeStyles(() => ({
  logoBackground: {
    height: '100%',
    width: '100%',
    position: 'absolute',
    '&:before': {
      width: '100%',
      height: '100%',
      backgroundImage: 'url("/images/simple-logo.svg")',
      backgroundSize: '50rem',
      backgroundPosition: '80%',
      backgroundRepeat: 'no-repeat',
      content: '" "',
      display: 'block',
      position: 'absolute',
      top: 0,
      left: 0,
      opacity: 0.3,
    }
  },
  hideFallbackMessage: {
    height: '100%',
    width: '100%',
    position: 'absolute',
    backgroundColor: 'white',
    zIndex: -1,
  }
}))

const LogoContainer = ({ children }) => {
  const classes = useStyles()
  return (
    <React.Fragment>
      <div className={classes.hideFallbackMessage} />
      <div className={classes.logoBackground} />
      <div style={{ backgroundColor: 'white' }}>
        {children}
      </div>
    </React.Fragment>
  )
}

export default LogoContainer